export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const AZIENDA = {
  nome: "Interventi Idraulici Andrea Morelli",
  telefono: "340 911 4543",
  telefonoLink: "tel:+393409114543",
  whatsappLink: "https://wa.me/393409114543",
  email: "fimasrls16@gmail.com",
  emailLink: "mailto:fimasrls16@gmail.com",
  indirizzo: "Viale San Lorenzo 39, 47838 Riccione (RN)",
  piva: "04285630408",
  mappaLink: "https://www.google.com/maps/search/?api=1&query=Viale+San+Lorenzo+39+47838+Riccione+RN",
};

export const TIPI_PROBLEMA = [
  "Perdita d'acqua",
  "Tubo rotto",
  "Scarico ostruito",
  "WC / sanitari",
  "Scaldabagno / acqua calda",
  "Sostituzione caldaia",
  "Autoclave / pressione",
  "Impianto industriale",
  "Altro",
];

export const URGENZE = {
  emergenza: { label: "Emergenza", cls: "bg-red-100 text-red-800 border-red-300" },
  oggi: { label: "In giornata", cls: "bg-orange-100 text-orange-800 border-orange-300" },
  programmato: { label: "Programmato", cls: "bg-slate-100 text-slate-700 border-slate-300" },
};

export const STATI = {
  nuovo: { label: "Nuovo", cls: "bg-amber-100 text-amber-800 border-amber-300" },
  in_corso: { label: "In corso", cls: "bg-sky-100 text-sky-800 border-sky-300" },
  completato: { label: "Completato", cls: "bg-emerald-100 text-emerald-800 border-emerald-300" },
  annullato: { label: "Annullato", cls: "bg-slate-100 text-slate-600 border-slate-300" },
};

export const IMPIANTI = { civile: "Civile", industriale: "Industriale", speciale: "Speciale" };

export const waNumero = (tel) => {
  const raw = tel.trim();
  const n = raw.replace(/\D/g, "");
  if (raw.startsWith("+")) return n;
  if (n.startsWith("00")) return n.slice(2);
  if (/^3\d{8,9}$/.test(n)) return `39${n}`;
  return n;
};

export const waLink = (tel, testo = "") =>
  `https://wa.me/${waNumero(tel)}?text=${encodeURIComponent(testo)}`;
